<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstOffenderSearchLog"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedOffenderSearchLog"
		dataKey="OffenderSearchLogID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--AdminName-->
				<th>
					<p-columnFilter type="text" field="AdminName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--HitCount-->
				<th>
					<!-- <p-columnFilter type="text" field="HitCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SearchDT-->
				<th>
					<!-- <p-columnFilter type="text" field="SearchDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--FirstName-->
				<!-- <th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th> -->

				<!--LastName-->
				<!-- <th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th> -->

				<!--DOB-->
				<th>
					<p-columnFilter type="text" field="DOB" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="AdminName">Admin<p-sortIcon field="AdminName"></p-sortIcon></th>
				<th pSortableColumn="HitCount">Hit Count<p-sortIcon field="HitCount"></p-sortIcon></th>
				<th pSortableColumn="SearchDT">Date<p-sortIcon field="SearchDT"></p-sortIcon></th>
				<!-- <th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th> -->
				<!-- <th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th> -->
				<th pSortableColumn="DOB">Date of Birth<p-sortIcon field="DOB"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-OffenderSearchLog>
			<tr [pSelectableRow]="OffenderSearchLog">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ OffenderSearchLog.AdminName }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ OffenderSearchLog.HitCount }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ OffenderSearchLog.SearchDTDesc }}
				</td>

				<!-- <td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ OffenderSearchLog.FirstName }}
				</td> -->

				<!-- <td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ OffenderSearchLog.LastName }}
				</td> -->

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ OffenderSearchLog.DOB }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
